import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import { IResponse, IPendingVendor, IPendingVendorPost, ICreateDocumentTemplate } from '../models';
export const getPendingVendors = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  searchText?: string;
  vendorStatuses?: string;
  documentStatuses?: string;
}): Promise<IResponse<IPendingVendor[]>> => {
  try {
    const { data } = await axios.get(`/api/pending-vendors`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getPotentialVendors failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createPendingVendor = async (
  payload: IPendingVendorPost
): Promise<ICreateDocumentTemplate[]> => {
  try {
    const { data } = await axios.post(`/api/pending-vendors`, payload);
    return data;
  } catch (error) {
    logError(error, 'createPendingVendor failed');
    return Promise.reject(error?.response?.data);
  }
};

export const rejectPendingVendor = async (pendingVendorId: string | number) => {
  try {
    const { data } = await axios.put(`/api/pending-vendors/${pendingVendorId}/reject`);
    return data;
  } catch (error) {
    logError(error, 'rejectPendingVendor failed');
    return Promise.reject(error?.response?.data);
  }
};

export const approvePendingVendor = async (
  pendingVendorId: string | number,
  payload: {
    vendorTypeId: string | number;
  }
) => {
  try {
    const { data } = await axios.put(`/api/pending-vendors/${pendingVendorId}/approve`, payload);
    return data;
  } catch (error) {
    logError(error, 'rejectPendingVendor failed');
    return Promise.reject(error?.response?.data);
  }
};

export const sendPendingVendorReminder = async (pendingVendorId: string | number) => {
  try {
    const { data } = await axios.post(`/api/pending-vendors/${pendingVendorId}/reminder`);
    return data;
  } catch (error) {
    logError(error, 'rejectPendingVendor failed');
    return Promise.reject(error?.response?.data);
  }
};
